import { ApiResponse } from "../models/http/Response";
import { SearchRequest } from "../models/http/SearchRequest";
import IQueryRepository from "../ports/IQueryRepository";

abstract class Query<T> {
  constructor(private repository: IQueryRepository<T>) {}

  public async search(body?: SearchRequest): Promise<ApiResponse<T>> {
    return this.repository.search(body);
  }
}

export default Query;
